export enum EMambaTermsStatus {
  REJECTED = 'REJECTED',
  NONE = 'NONE',
  ACCEPTED = 'ACCEPTED',
}
